import { useRef } from "react";

import { HARD_BREAK_MOBILE_PX } from "@/constants";
import useBreakpoint from "@/hooks/useBreakpoint";
import { cx } from "@/utils";

import EpisodesContext from "./EpisodesContext";

import styles from "./Episodes.module.css";

type EpisodeSettings = {
  searchIsProcessing?: boolean;
  is_report?: boolean;
  hideTags?: boolean;
  hideSimilar?: boolean;
  hideActions?: boolean;
};

type EpisodesProps = {
  className?: string;
} & EpisodeSettings &
  React.HTMLProps<HTMLDivElement>;

const Episodes: React.FunctionComponent<EpisodesProps> = ({
  children,
  className,
  ...rest
}) => {
  const ref = useRef<typeof document.body>(document.body);
  const mobile = useBreakpoint(ref, HARD_BREAK_MOBILE_PX, false);

  return (
    <EpisodesContext.Provider
      value={{
        mobile,
      }}
    >
      <div
        data-testid="episodes-container"
        className={cx("episodes-container", styles.root, className)}
        {...rest}
      >
        {children}
      </div>
    </EpisodesContext.Provider>
  );
};

export default Episodes;
